import { render, staticRenderFns } from "./DefaultProductsList.vue?vue&type=template&id=236a026c&scoped=true"
import script from "./DefaultProductsList.vue?vue&type=script&lang=js"
export * from "./DefaultProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a026c",
  null
  
)

export default component.exports